import clsx from 'clsx'

import { Tooltip, type TooltipProps } from '@fv/client-components'

type Props = Omit<TooltipProps, 'portalToRoot'>
export const ShipperTooltip = (props: Props) => {
  return (
    <Tooltip
      {...props}
      portalToRoot
      classNames={{
        popup: clsx(
          'border-2 pointer-events-none rounded-[0.3rem] py-2 px-3 text-sm border-fv-gray bg-white',
          props.classNames?.popup,
        ),
        arrow: clsx(
          'bg-white border-2 border-fv-gray rotate-45 h-2 w-2',
          'data-[side=top]:border-l-0 data-[side=top]:border-t-0 data-[side=top]:-bottom-1',
          'data-[side=bottom]:border-r-0 data-[side=bottom]:border-b-0 data-[side=bottom]:-top-1',
        ),
      }}
    />
  )
}
